export default "__VITE_ASSET__BiVa0MVh__"